var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"motor-list"},[_c('div',{staticClass:"heading",domProps:{"textContent":_vm._s(_vm.type.name)}}),_c('div',{staticClass:"motors"},_vm._l((_vm.groupedList),function(motor,key){return _c('MotorPickerTypeMotor',{key:key,attrs:{"motor":motor,"type":_vm.type,"isAvailable":motor.available}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }